import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Toolbar,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import Logo from "../../assets/logo.png";
import "./Header.css";
import BellIcon from "../../CommonComponents/common/BellIcon";
import MessageIcon from "../../CommonComponents/common/MessageIcon";
import { useLocation } from "react-router-dom";
import ProfileDropdown from "../../CommonComponents/TopSection/ProfileDropdown";
import MessageDrawer from "../../CommonComponents/TopSection/MessageDrawer";
import NotificationDropdown from "../../CommonComponents/TopSection/NotificationDropdown";
import NotificationComponent from "../../CommonComponents/TopSection/NotificationComponent";
import Alerts from "../../CommonComponents/TopSection/Alerts";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedRegion, setSelectedPlant } from "../../redux/userSlice";

const Header = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isDev = process.env.REACT_APP_ENVT === "DEV";
  const {
    approvedRegions = [],   // e.g., ["EMEA", "AMERICAS"]
    approvedPlants = [],    // e.g., ["5060", "3040", "6666"]
    selectedRegion = "",
    selectedPlant = "",
    regionPlantMapping = {} // NEW: store RAW mapping here in redux
  } = useSelector((s) => s.user || {});

  const availableRegions = useMemo(
    () => approvedRegions.map(r => ({ id: r, name: r })),
    [approvedRegions]
  );

  const availablePlants = useMemo(
    () => selectedRegion ? (regionPlantMapping[selectedRegion] || []).map(p => ({ id: p, name: p })) : [],
    [selectedRegion, regionPlantMapping]
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAlertsOpen, setIsAlertsOpen] = useState(false);
  const [showNotificationDropdown, setShowNotificationDropdown] =
    useState(false);
  const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] =
    useState(false);

  // master region/plant data aligned with AccessRequestForm
  // const REGION_PLANT_DATA = {
  //   regions: [
  //     { id: "GLOBAL", name: "GLOBAL" },
  //     { id: "AMERICAS", name: "AMERICAS" },
  //     { id: "EMEA", name: "EMEA" },
  //     { id: "APAC", name: "APAC" },
  //   ],
  //   plants: {
  //     GLOBAL: [
  //       { id: "P-001", name: "P-001" },
  //       { id: "P-002", name: "P-002" },
  //       { id: "P-003", name: "P-003" },
  //       { id: "P-004", name: "P-004" },
  //       { id: "P-005", name: "P-005" },
  //       { id: "P-006", name: "P-006" },
  //       { id: "P-007", name: "P-007" },
  //       { id: "P-008", name: "P-008" },
  //       { id: "P-009", name: "P-009" },
  //       { id: "P-010", name: "P-010" },
  //     ],
  //     AMERICAS: [
  //       { id: "P-001", name: "P-001" },
  //       { id: "P-005", name: "P-005" },
  //       { id: "P-006", name: "P-006" },
  //       { id: "P-011", name: "P-011" },
  //       { id: "P-012", name: "P-012" },
  //     ],
  //     EMEA: [
  //       { id: "P-002", name: "P-002" },
  //       { id: "P-007", name: "P-007" },
  //       { id: "P-008", name: "P-008" },
  //       { id: "P-013", name: "P-013" },
  //     ],
  //     APAC: [
  //       { id: "P-003", name: "P-003" },
  //       { id: "P-009", name: "P-009" },
  //       { id: "P-010", name: "P-010" },
  //       { id: "P-014", name: "P-014" },
  //       { id: "P-015", name: "P-015" },
  //     ],
  //   },
  // };


  const excludedRoutes = ["alert-preferences", "user-roles"];
  const normalizedPath = (location.pathname || "").toLowerCase();
  const shouldShowCascader = !excludedRoutes.some((route) =>
    normalizedPath.includes(route)
  );

  // derive regions to show: prefer approvedRegions, else derive from approvedPlants, else show all
  // const availableRegions = useMemo(() => {
  //   if (approvedRegions && approvedRegions.length) {
  //     return REGION_PLANT_DATA.regions.filter((r) =>
  //       approvedRegions.includes(r.id)
  //     );
  //   }
  //   if (approvedPlants && approvedPlants.length) {
  //     const regionIds = new Set();
  //     Object.entries(REGION_PLANT_DATA.plants).forEach(([regionId, plants]) => {
  //       if (plants.some((p) => approvedPlants.includes(p.id)))
  //         regionIds.add(regionId);
  //     });
  //     return REGION_PLANT_DATA.regions.filter((r) => regionIds.has(r.id));
  //   }
  //   return REGION_PLANT_DATA.regions;
  // }, [approvedRegions, approvedPlants]);

  // const masterPlantsForRegion = useMemo(() => {
  //   if (!selectedRegion) return [];
  //   return REGION_PLANT_DATA.plants[selectedRegion] || [];
  // }, [selectedRegion]);

  // const availablePlants = useMemo(() => {
  //   if (!selectedRegion) return [];
  //   if (approvedPlants && approvedPlants.length) {
  //     return masterPlantsForRegion.filter((p) => approvedPlants.includes(p.id));
  //   }
  //   return masterPlantsForRegion;
  // }, [selectedRegion, masterPlantsForRegion, approvedPlants]);
  // Region list from approvedRegions


  useEffect(() => {
    if (selectedPlant && !availablePlants.find((p) => p.id === selectedPlant)) {
      dispatch(setSelectedPlant(""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availablePlants, selectedPlant]);

  const isDashboard = location.pathname === "/ct-dashboard";
  const isUserRolesPage = location.pathname === "/core/user-roles";
  const toggleDrawer = () => setIsDrawerOpen((p) => !p);
  const toggleAlertsDrawer = () => setIsAlertsOpen((p) => !p);

  const handleBellClick = () => {
    if (isDashboard) toggleAlertsDrawer();
    else setShowNotificationDropdown((p) => !p);
  };

  const dropdownRef = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNotificationDropdown(false);
      }
    }
    if (showNotificationDropdown)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNotificationDropdown]);

  return (
    <div className="main-header" ref={props?.headerRef}>
      <Toolbar className="toolbar_header">
        <div className="main-box">
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <img src={Logo} alt="logo" width={64} height={20} />
            <h3>Technical, Innovation & Supply Chain</h3>
          </div>

          {props.showIcons !== false && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "12px",
              }}
            >
              {/* {isDev && shouldShowCascader && (
                <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                  {approvedPlants?.length || approvedRegions?.length ? (
                    <Chip
                      label=""
                      size="small" 
                    // sx={{
                    //   backgroundColor: "#4CAF50",
                    //   color: "#fff",
                    //   height: 24,
                    // }}
                    />
                  ) : null}

                  <FormControl size="small" sx={{ minWidth: 150 }}>
                    <InputLabel
                      id="header-region-label"
                      sx={{
                        color: "#fff", fontSize: "0.6rem",
                        "&.Mui-focused": {
                          color: "#fff",
                        },
                      }}
                    >
                      Region
                    </InputLabel>
                    <Select
                      labelId="header-region-label"
                      id="header-region-select"
                      value={selectedRegion}
                      label="Region"
                      onChange={(e) => dispatch(setSelectedRegion(e.target.value))}
                      sx={{
                        color: "#fff",
                        fontSize: "0.6rem",
                        "& .MuiSelect-icon": {
                          color: "#fff",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#fff",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#fff",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#fff",
                        },
                      }}
                    >
                       <MenuItem value="">
                        <em>Select Region</em>
                      </MenuItem> 
                      {availableRegions.map((region) => (
                        <MenuItem key={region.id} value={region.id}>
                          {region.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}

              {/* Plant Dropdown */}
              {/* <FormControl
                    size="small"
                    sx={{ minWidth: 150, marginRight: 2 }}
                    disabled={!selectedRegion}
                  >
                    <InputLabel
                      id="header-plant-label"
                      sx={{
                        color: selectedRegion ? "#fff" : "#ccc",
                        fontSize: "0.6rem",
                        "&.Mui-focused": {
                          color: "#fff",
                        },
                        "&.Mui-disabled": {
                          color: "#ccc",
                        },
                      }}
                    >
                      Plant
                    </InputLabel>
                    <Select
                      labelId="header-plant-label"
                      id="header-plant-select"
                      value={selectedPlant}
                      label="Plant"
                      onChange={(e) => dispatch(setSelectedPlant(e.target.value))}
                      disabled={!selectedRegion}
                      sx={{
                        color: selectedRegion ? "#fff" : "#ccc",
                        fontSize: "0.6rem",
                        "& .MuiSelect-icon": {
                          color: selectedRegion ? "#fff" : "#ccc",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: selectedRegion ? "#fff" : "#999",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: selectedRegion ? "#fff" : "#999",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#fff",
                        },
                        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#999",
                        },
                      }}
                    > 
                       <MenuItem value="">
                        <em>Select Plant</em>
                      </MenuItem> 
                      {availablePlants.map((plant) => (
                        <MenuItem key={plant.id} value={plant.id}>
                          {plant.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              )} */}

              {!isUserRolesPage && (
                <div
                  onClick={isDev ? toggleDrawer : undefined}
                  style={{
                    cursor: isDev ? "pointer" : "default",
                    opacity: isDev ? 1 : 0.4,
                    pointerEvents: isDev ? "auto" : "none",
                  }}
                >
                  <MessageIcon />
                </div>
              )}

              {isDev && (
                <MessageDrawer
                  open={isDrawerOpen}
                  onClose={toggleDrawer}
                />
              )}

              {!isUserRolesPage && <div
                style={{ cursor: "pointer", position: "relative" }}
                ref={dropdownRef}
              >
                <span onClick={handleBellClick}>
                  <BellIcon />
                </span>

                {!isDashboard && showNotificationDropdown && (
                  <NotificationDropdown
                    onAlertsClick={() => {
                      setShowNotificationDropdown(false);
                      setIsAlertsOpen(true);
                    }}
                    onNotificationsClick={() => {
                      setShowNotificationDropdown(false);
                      setIsNotificationDrawerOpen(true);
                    }}
                  />
                )}
              </div>}
              <Alerts open={isAlertsOpen} onClose={toggleAlertsDrawer} />

              <NotificationComponent
                open={isNotificationDrawerOpen}
                onClose={() => setIsNotificationDrawerOpen(false)}
              />
              <ProfileDropdown />
            </div>
          )}
        </div>
      </Toolbar>

      <div className="gradient_section">
        <span className="env-text">
          {process.env.REACT_APP_ENVT === "DEV"
            ? "DEV Environment"
            : process.env.REACT_APP_ENVT === "SIT"
              ? "SIT Environment"
              : process.env.REACT_APP_ENVT === "UAT"
                ? "UAT Environment"
                : ""}
        </span>
      </div>
    </div>
  );
};

export default Header;
